import { AfterViewInit, ChangeDetectorRef, Component, effect, HostListener, inject, OnDestroy, OnInit } from "@angular/core";
import { NavigationEnd, Router, RouterLink, RouterModule } from "@angular/router";
import { SanitizerPipe } from "./pipes/sanitizer.pipe";
import { SVG_ICONS } from "./models/icons";
import { CommonModule } from "@angular/common";
import { GlobalService } from "./serivces/global.service";
import { MasterService } from "./serivces/master.service";
import { Subscription } from "rxjs";

@Component({
  imports: [RouterModule, SanitizerPipe, CommonModule, RouterLink],
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent implements OnInit, OnDestroy {
  private globalService = inject(GlobalService);
  private masterService = inject(MasterService);
  public router = inject(Router);
  private routerSub!: Subscription;
  public isLoginPage = false;

  private cdr = inject(ChangeDetectorRef);

  constructor() {
    // Consolidate all signal-driven logic into ONE effect
    effect(() => {
      // --- Read all signals first ---
      const isLoggedIn = this.globalService.IsLoggedIn();
      const isShow = this.globalService.IsShow();

      // --- Write to class properties ---
      this.isLoggedIn = isLoggedIn;
      this.showSideBar = isShow;

      // --- Run your side-effect logic ---
      if (isLoggedIn) {
        this.initializeUserData();
        this.onGetPermission();
      } else {
        // Clear data
        this.userDetails = null;
        this.centerDetails = null;
        this.centerList = [];
        this.userMenus = [];
      }

      // --- 2. Force change detection to run AGAIN ---
      // This tells Angular to update the view with the new
      // values of 'isLoggedIn' and 'showSideBar'.
      this.cdr.detectChanges();
    });
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
      }
    });

    this.checkScreenSize();
    const storedSelection = sessionStorage.getItem("selectedCenter");
    if (storedSelection) {
      try {
        const parsed = JSON.parse(storedSelection);
        this.selectedCenterIds = Array.isArray(parsed) ? parsed : [parsed].filter(Boolean);
      } catch (e) {
        this.selectedCenterIds = [storedSelection].filter(Boolean).map(Number);
      }
    }
    const savedParentMenu = sessionStorage.getItem("selectedParentMenu");
    const savedChildMenu = sessionStorage.getItem("selectedChildMenu");
    if (savedParentMenu) {
      this.selectedParentMenu = JSON.parse(savedParentMenu);
      if (savedChildMenu) {
        this.selectedChildMenu = JSON.parse(savedChildMenu);
      } else if (this.selectedParentMenu?.children?.length > 0) {
        // If no child was saved but parent has children, select the first one

        this.onChildMenuClick(this.selectedParentMenu.children[0], this.selectedParentMenu.RouterPath);
      }
    }

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        //  this.isSidebarExpanded = !this.isMobile;
        if (this.isMobile) {
          this.isSidebarExpanded = false;
        }
        this.isLoginPage = event.url === "/login" || event.url === "/";
      }
    });

    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.isDropdownOpen = false;
        this.isProfileDropdownOpen = false;
      }
    });
    this.userTypeID = +sessionStorage.getItem("UserTypeID")! || 0;
  }

  //#region variables
  isMobile = false;
  isSidebarExpanded = true;
  hoveredItem: string | null = null;
  isDropdownOpen = false;
  isProfileDropdownOpen = false;
  showSideBar = true;
  isLoggedIn = true;
  userMenus: any[] = [];
  readonly SVG_ICONS = SVG_ICONS;
  UserID = 0;
  TrainerID = 0;
  CenterID = 0;
  userDetails: any;
  centerDetails: any;
  centerList: any;
  showPopup = false;
  hovered = null;
  firstCenterID = 0;
  selectedCenterIds: number[] = [];
  userTypeID = 0;
  selectedParentMenu: any = null;
  selectedChildMenu: any = null;
  profileImage = "";

  //#endregion

  private initializeUserData() {
    const menuData = sessionStorage.getItem("permissions");
    if (menuData) {
      const menus = JSON.parse(menuData).filter((menu: any) => menu.CanView);
      // const uniqueMenus = menus.filter((menu: any, index: number, self: any[]) => index === self.findIndex(m => m.MenuID === menu.MenuID));

      // Build hierarchical menu structure
      this.userMenus = this.buildMenuHierarchy(menus);
    }

    if (sessionStorage.getItem("Token")) {
      this.UserID = +sessionStorage.getItem("UserID")! || 0;
      this.TrainerID = +sessionStorage.getItem("TrainerID")! || 0;
      const centerIDsKey = "AllCenterIDs";
      const storedIDsString = sessionStorage.getItem(centerIDsKey);
      this.getCenterList();

      let centerIDs: number[] = [];
      if (storedIDsString) {
        centerIDs = JSON.parse(storedIDsString);
        if (centerIDs.length > 0) {
          this.firstCenterID = centerIDs[0];
        }
      }

      this.getCenterDetailsByID();
      this.getUserByID();
      this.getCenterList();
    }
  }

  // Build hierarchical menu structure
  buildMenuHierarchy(menus: any[]): any[] {
    const menuMap = new Map<number, any>();
    const rootMenus: any[] = [];

    // Sort by iOrder first
    menus.sort((a, b) => a.iOrder - b.iOrder);

    // Create a map of all menus with children array
    menus.forEach(menu => {
      menuMap.set(menu.MenuID, { ...menu, children: [] });
    });

    // Build the hierarchy
    menus.forEach(menu => {
      const menuItem = menuMap.get(menu.MenuID);
      if (menu.ParentMenuID === 0) {
        // Root level menu
        rootMenus.push(menuItem);
      } else {
        // Child menu
        const parent = menuMap.get(menu.ParentMenuID);
        if (parent) {
          parent.children.push(menuItem);
        }
      }
    });

    return rootMenus;
  }
  onGetPermission() {
    const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");
    if (permissions.length) {
      const permissionList: string[] = [];
      permissions.forEach((permission: any) => {
        permissionList.push(permission.RouterPath.replace("/", ""));
      });
      this.globalService.permission.set(permissionList);
    }
  }

  // Handle parent menu click - show child menu bar
  onMenuClick(menu: any, event?: Event) {
    if (event) {
      event.stopPropagation();
    }

    if (menu.children && menu.children.length > 0) {
      // Toggle child menu bar
      if (this.selectedParentMenu?.MenuID === menu.MenuID) {
        this.selectedParentMenu = null;
        sessionStorage.removeItem("selectedParentMenu");
        sessionStorage.removeItem("selectedChildMenu");
      } else {
        this.selectedParentMenu = menu;
        sessionStorage.setItem("selectedParentMenu", JSON.stringify(menu));
        // Automatically select the first child only on desktop
        if (!this.isMobile && menu.children && menu.children.length > 0) {
          this.onChildMenuClick(menu.children[0], menu.RouterPath);
        }
      }
      this.selectedChildMenu = null;
    } else {
      this.selectedParentMenu = null;
      this.selectedChildMenu = null;
      sessionStorage.removeItem("selectedParentMenu");
      sessionStorage.removeItem("selectedChildMenu");
      this.router.navigate([menu.RouterPath]);
    }
  }

  onChildMenuClick(child: any, parentRouterPath: string, event?: Event) {
    if (event) event?.stopPropagation();

    this.selectedChildMenu = child;
    sessionStorage.setItem("selectedChildMenu", JSON.stringify(child));
    this.router.navigate([parentRouterPath + child.RouterPath]);
    // this.router.navigate(["report/" + child.RouterPath]);
  }

  isSelected(center: any): boolean {
    return this.selectedCenterIds.includes(center.CenterID);
  }

  navigateAndCloseDropdown(route: string) {
    this.isDropdownOpen = false;
    this.router.navigate([route]);
  }

  getCenterDetailsByID() {
    this.masterService.getCenterDetailsByID(this.firstCenterID).subscribe((res: any) => {
      this.centerDetails = res;
    });
  }

  getUserByID() {
    this.masterService.getCoachDetailsByID(this.TrainerID).subscribe((res: any) => {
      const { Table } = res;
      this.userDetails = Table;

      // Get first IMAGE document
      this.profileImage = Table?.Documents?.find((d: any) => d.FileType === "IMAGE")?.URL || "public/profile.png";
    });
  }

  onImgError(event: Event) {
    (event.target as HTMLImageElement).src = "public/no-image.jpg";
  }

  getCenterList() {
    this.masterService.getCenterList(1, 10000, "").subscribe((res: any) => {
      const storedIDs = sessionStorage.getItem("AllCenterIDs");
      const centerIDs: number[] = storedIDs ? JSON.parse(storedIDs) : [];

      this.centerList = res.data;
      this.centerList = this.centerList.filter((item: any) => centerIDs.includes(item.CenterID));
      this.updateDisplayText();
    });
  }

  togglePopup(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.showPopup = !this.showPopup;
    if (this.showPopup && this.centerList.length === 0) {
      this.getCenterList();
    }
  }

  applySelection() {
    sessionStorage.setItem("selectedCenter", JSON.stringify(this.selectedCenterIds));
    this.showPopup = false;
    this.updateDisplayText();
    window.location.reload();
  }

  onCenterSelectionChange(event: any, center: any) {
    if (event.target.checked) {
      if (!this.selectedCenterIds.includes(center.CenterID)) {
        this.selectedCenterIds.push(center.CenterID);
      }
    } else {
      const index = this.selectedCenterIds.indexOf(center.CenterID);
      if (index > -1) {
        this.selectedCenterIds.splice(index, 1);
      }
    }
  }

  toggleSelectAll(event: any) {
    if (event.target.checked) {
      this.selectedCenterIds = this.centerList.map((center: any) => center.CenterID);
    } else {
      this.selectedCenterIds = [];
    }
  }

  updateDisplayText() {
    if (this.selectedCenterIds.length === 0) {
      this.centerDetails = { CenterName: "No Center Selected", Address: "Please select one or more centers." };
    } else if (this.selectedCenterIds.length === 1) {
      const singleCenter = this.centerList.find((c: any) => c.CenterID === this.selectedCenterIds[0]);
      if (singleCenter) {
        this.centerDetails = singleCenter;
      }
    } else {
      this.centerDetails = {
        CenterName: `${this.selectedCenterIds.length} Centers Selected`,
        Address: "Click to view or modify selection",
      };
    }
  }

  selectCenter(center: any) {
    this.centerDetails = center;
    this.showPopup = false;
    sessionStorage.setItem("CenterID", center.CenterID);
  }

  toggleSidebar(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.isSidebarExpanded = !this.isSidebarExpanded;
    if (this.isMobile) {
      // document.body.classList.toggle("no-scroll", this.isSidebarExpanded);
    } else {
      document.body.classList.toggle("no-scroll", this.isSidebarExpanded);
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  toggleProfileDropdown(event: Event) {
    event.stopPropagation();
    this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
  }

  @HostListener("document:click", ["$event"])
  closeDropdownOnOutsideClick(event: Event) {
    this.isProfileDropdownOpen = false;
    this.isDropdownOpen = false;
    this.showPopup = false;

    if (this.isMobile && this.isSidebarExpanded) {
      const sidebar = document.querySelector(".sidebar");
      const toggleBtn = document.querySelector(".navbar-top button"); // Adjust selector if needed

      // Check if click is outside sidebar and toggle button
      if (sidebar && !sidebar.contains(event.target as Node) && toggleBtn && !toggleBtn.contains(event.target as Node)) {
        this.isSidebarExpanded = false;
      }
    }

    // Close child menu panels when clicking outside
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 768;

    // Only auto-collapse/expand if state actually changed
    if (wasMobile !== this.isMobile) {
      if (this.isMobile) {
        this.isSidebarExpanded = false; // Default to closed on mobile
      } else {
        this.isSidebarExpanded = true; // Default to open on desktop
      }
    }
  }

  closeAllDropdownsExcept(name: string) {
    if (name !== "profile") {
      this.isProfileDropdownOpen = false;
    }
  }

  async logout(event?: Event) {
    await this.globalService.onLogout().subscribe((res: any) => {});
    await this.router.navigate(["login"]);
    await sessionStorage.clear();
  }

  isRouteActive(route: string): boolean {
    const currentUrl = this.router.url.split("?")[0];
    return currentUrl === route;
  }

  ngOnDestroy() {
    this.routerSub.unsubscribe();
  }
}
